"use client";

import Link from "next/link";
import { UserRound } from "lucide-react";
import { useEffect, useState } from "react";

export function AccountNav() {
  const [authenticated, setAuthenticated] = useState<boolean | null>(null);
  useEffect(() => {
    const controller = new AbortController();
    fetch("/api/account/session", { cache: "no-store", signal: controller.signal })
      .then((response) => response.json())
      .then((data) => setAuthenticated(Boolean(data.authenticated)))
      .catch(() => setAuthenticated(false));
    return () => controller.abort();
  }, []);
  const href = authenticated ? "/moje-spolki" : "/konto/logowanie";
  const label = authenticated ? "Moje spółki" : "Zaloguj";
  return (
    <Link aria-label={label} className="inline-flex min-h-10 shrink-0 items-center justify-center gap-2 rounded-md border border-white/15 bg-white/[0.04] px-3 text-sm font-semibold text-slate-100 transition hover:border-[#3498db]/60 hover:bg-[#3498db]/10" href={href}>
      <UserRound aria-hidden="true" className="size-4" />
      <span className="hidden sm:inline">{label}</span>
    </Link>
  );
}
